import { render, staticRenderFns } from "./RegisterVerifySms.vue?vue&type=template&id=2df98a8b&"
import script from "./RegisterVerifySms.vue?vue&type=script&lang=ts&"
export * from "./RegisterVerifySms.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports